// @flow
import * as pubnubService from '../../services/pubnubService';
import {
    createPubnubCatalogOnMessageReceived,
    createPubnubCatalogOnPresence,
    createPubnubCatalogOnStatus,
    hereNow,
} from '../../redux/modules/pubnub';
import { getPubnubPublishKey, getPubnubSessionId } from '../../redux/modules/console';
import { bindActionCreators } from 'redux';
import { Component } from 'react';
import { connect } from 'react-redux';
import type { ExtractReturn } from '../../types/redux';
import { getPubnubSubscribeKey } from '../../redux/modules/config';

/* eslint-disable */
const catalogCardMessages = ["'lot-loaded'", "'auction-opened'", "'auction-closed'"];

const catalogPageMessages = [
    "'ask-changed'",
    "'auction-closed'",
    "'auction-opened'",
    "'bid-accepted'",
    "'bid-retracted'",
    "'lot-closed'",
    "'lot-loaded'",
    "'lot-passed'",
    "'lot-reopened'",
    "'lot-skipped'",
    "'lot-sold'",
    "'lot-unsold'",
];

export const upcomimngItemCardMessages = ["'lot-loaded'"];

const itemCardMessages = [
    "'ask-changed'",
    "'bid-accepted'",
    "'bid-retracted'",
    "'lot-closed'",
    "'lot-loaded'",
    "'lot-passed'",
    "'lot-reopened'",
    "'lot-skipped'",
    "'lot-sold'",
    "'lot-unsold'",
];
/* eslint-enable */

const filters = {
    catalogCard: `(((${catalogCardMessages.join(', ')}) contains EventType) || isPresenceEvent)`,
    catalogPageConsole: `(((${catalogPageMessages.join(', ')}) contains EventType) || isPresenceEvent)`,
    itemCard: `(((${itemCardMessages.join(', ')}) contains EventType) || isPresenceEvent)`,
};

type OwnProps = $ReadOnly<{|
    catalogId: number,
    limitMessagesFilter: string,
    presenceOnly: boolean,
|}>;

const mapStateToProps = (state, { catalogId }) => {
    const publishKey = getPubnubPublishKey(state, catalogId);
    const subscribeKey = getPubnubSubscribeKey(state);
    const sessionId = getPubnubSessionId(state);

    return {
        catalogId,
        channel: `catalog.${catalogId}`,
        publishKey,
        sessionId,
        subscribeKey,
    };
};

const mapDispatchToProps = (dispatch: Function, { catalogId }: { catalogId: number }) =>
    bindActionCreators(
        {
            hereNow,
            onMessage: createPubnubCatalogOnMessageReceived(catalogId),
            onPresence: createPubnubCatalogOnPresence(catalogId),
            onStatus: createPubnubCatalogOnStatus(catalogId, `catalog.${catalogId}`),
        },
        dispatch
    );

type ReduxProps = $ReadOnly<{|
    ...ExtractReturn<typeof mapStateToProps>,
    channel: string,
    publishKey: string,
    sessionId: string,
    subscribeKey: string,
|}>;
type ReduxActions = $ReadOnly<{|
    hereNow: Function,
    onMessage: Function,
    onPresence: Function,
    onStatus: Function,
|}>;

type Props = $ReadOnly<{|
    ...OwnProps,
    ...ReduxProps,
    ...ReduxActions,
|}>;

type State = {
    pubnubChannel: any,
};

class PubnubCatalogContainer extends Component<Props, State> {
    static defaultProps = {
        presenceOnly: false,
    };

    state = {
        pubnubChannel: null,
    };

    componentDidMount() {
        this.connectToPubnub();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.publishKey !== this.props.publishKey) {
            this.connectToPubnub();
        }
    }

    componentWillUnmount() {
        const { pubnubChannel } = this.state;
        if (pubnubChannel) {
            pubnubChannel.unsubscribe();
            this.setState({ pubnubChannel: null });
        }
        if (this.keepaliveCheckTimeout) {
            clearTimeout(this.keepaliveCheckTimeout);
        }
    }

    keepaliveCheckTimeout: TimeoutID;

    connectToPubnub = async () => {
        if (this.keepaliveCheckTimeout) {
            clearTimeout(this.keepaliveCheckTimeout);
        }
        const {
            catalogId,
            channel,
            limitMessagesFilter,
            onMessage,
            onPresence,
            onStatus,
            presenceOnly,
            publishKey,
            sessionId,
            subscribeKey,
        } = this.props;
        const { pubnubChannel } = this.state;

        const filterExpression = limitMessagesFilter ? filters[limitMessagesFilter] : '';

        if (pubnubChannel) {
            pubnubChannel.unsubscribe();
        }

        await pubnubService.connect(publishKey, sessionId, subscribeKey);
        pubnubService.setFilterExpression(filterExpression);
        const newpubnubChannel = await pubnubService.subscribe(channel, onPresence, onMessage, onStatus, presenceOnly);

        this.props.hereNow(catalogId);
        this.setState({ pubnubChannel: newpubnubChannel });
        this.keepaliveCheck();
    };

    keepaliveCheck = () => {
        this.keepaliveCheckTimeout = setTimeout(() => {
            pubnubService
                .keepalive()
                .then(this.keepaliveCheck)
                .catch(this.connectToPubnub);
        }, 60000);
    };

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PubnubCatalogContainer);
